
// import Typography from '@mui/material/Typography';
// import * as React from 'react';

// import { Box, Card, Grid } from "@mui/material";

// import PlayCircleIcon from '@mui/icons-material/PlayCircle';
// import { SuggestionSimulatorComponentForCampaign } from './suggestionSimulatorComponentForCampaign';



// export function RichCardCarouselCardCampaignSimulator({ richCardCarouselCard }) {
//     return (
//         <>  <Grid style={{ display: "flex", overflow: "auto", width: "100%" }} >

//             {richCardCarouselCard.cardContents.map((cardContent) => (<Grid item
//                 sx={{
//                     minWidth: richCardCarouselCard.cardWidth !== "SMALL" ? "15vw" : "9vw",
//                     maxWidth: richCardCarouselCard.cardWidth !== "SMALL" ? "15vw" : "9vw"
//                 }}


//                 minHeight={"40vh"} maxHeight={"50vh"} padding={2}>

//                 <Card sx={{ height: "100%", border: "1px solid grey", borderRadius: "10px" }} >



//                     <Box >
//                         {cardContent.media.contentInfo.thumbnailUrl ? <>

//                             <Grid className="play-button-container" style={{ position: "relative" }}>
//                                 <img src={cardContent.media.contentInfo.thumbnailUrl} style={{
//                                     height: cardContent.media.height === "SHORT" ? "100px" : "130px",
//                                     width: "100%",
//                                     display: "block"
//                                 }
//                                 } className="image" />
//                                 <Grid className="play-button-overlay" style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)" }}>
//                                     {/* You can replace the content inside the overlay Grid with your own play button logo */}
//                                     <PlayCircleIcon sx={{ fontSize: 40, color: "white" }} />
//                                 </Grid>
//                             </Grid>


//                             {/* <img
//                                                               src={cardContent.media.contentInfo.thumbnailUrl}

//                                                               style={{
//                                                                   height: cardContent.media.height === "SHORT" ? "100px" : "130px",
//                                                                   width: "100%"
//                                                               }
//                                                               }
//                                                           /> */}

//                         </> :
//                             <>
//                                 <img
//                                     src={cardContent.media.contentInfo.fileUrl}

//                                     style={{
//                                         height: cardContent.media.height === "SHORT" ? "100px" : "130px",
//                                         width: "100%"
//                                     }
//                                     }
//                                 />

//                             </>
//                         }

//                     </Box>
//                     <Box padding={2}>
//                         <Typography variant="h6" fontWeight={"bold"} sx={{ lineBreak: "auto", wordBreak: "break-word", padding: 1 }} >

//                             {cardContent.title && cardContent.title.length > 38 ? `${cardContent.title.substr(0, 25)}...` : cardContent.title}

//                         </Typography>
//                         <Typography variant="body2" sx={{ lineBreak: "auto", wordBreak: "break-word", padding: 1 }} >
//                             {/* {cardContent.cardDescription} */}
//                             {cardContent.description.length > 25 ? `${cardContent.description.substr(0, 25)}...` : cardContent.description}



//                         </Typography>

//                         <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100%", flexDirection: "column", paddingTop: 4 }}>


//                             {cardContent.suggestions.map((suggestion, index) => (
//                                 <Box sx={{ width: "100%", display: "flex", flexDirection: "column", alignItems: "center" }}>
//                                     <SuggestionSimulatorComponentForCampaign suggestion={suggestion} />
//                                     {index + 1 < cardContent.suggestions.length &&

//                                         <hr style={{ width: "60%", border: "1px solid black", margin: 3 }} />
//                                     }
//                                 </Box>
//                             ))}
//                         </Box>

//                     </Box>





//                 </Card>
//             </Grid>))}



//         </Grid></>
//     )
// }

import React from 'react';
import { Box, Card, Grid, Typography } from "@mui/material";
import { SuggestionSimulatorComponentForCampaign } from './suggestionSimulatorComponentForCampaign';
import { MediaHandler } from '../../rcsManagement/rcsTemplates/simulator/MediaHandler';

export function RichCardCarouselCardCampaignSimulator({ richCardCarouselCard }) {
    // Helper to get card width
    const getCardWidth = () => {
        return richCardCarouselCard.cardWidth !== "SMALL" ? "15vw" : "9vw";
    };

    // Helper to get media height
    const getMediaHeight = (cardContent) => {
        return cardContent.media.height === "SHORT" ? "100px" : "130px";
    };

    // Helper to truncate text
    const truncateText = (text, maxLength) => {
        if (!text) return "";
        return text.length > maxLength ? `${text.substring(0, maxLength)}...` : text;
    };

    // Helper to prepare media object for MediaHandler
    function getMediaTypeFromUrl(mediaUrl) {
        if (!mediaUrl) return "";

        const extension = mediaUrl.split(".").pop().toLowerCase();

        const imageTypes = ["jpg", "jpeg", "png", "gif", "webp", "svg"];
        const videoTypes = ["mp4", "webm", "ogg", "mov", "avi", "mkv", "video/mp4"];
        const docTypes = ["application/pdf", "pdf"];
        if (imageTypes.includes(extension)) return "image/jpeg";
        if (videoTypes.includes(extension)) return "video/mp4";
        if (docTypes.includes(extension)) return "application/pdf";

        return "unknown";
    }

    const getMediaObject = (cardContent) => {
        return {
            url: cardContent.media.contentInfo.fileUrl,
            type: getMediaTypeFromUrl(cardContent.media.contentInfo.fileUrl)
        };
    };

    // Helper to prepare thumbnail object for MediaHandler
    const getThumbnailObject = (cardContent) => {
        return cardContent.media.contentInfo.thumbnailUrl
            ? { url: cardContent.media.contentInfo.thumbnailUrl }
            : null;
    };

    return (
        <Grid
            style={{
                display: "flex",
                overflow: "auto",
                width: "100%"
            }}
        >
            {richCardCarouselCard.cardContents.map((cardContent, index) => (
                <Grid
                    key={index}
                    item
                    sx={{
                        minWidth: getCardWidth(),
                        maxWidth: getCardWidth()
                    }}
                    minHeight="40vh"
                    maxHeight="50vh"
                    padding={2}
                >
                    <Card
                        sx={{
                            // height: "100%",
                            border: "1px solid grey",
                            borderRadius: "10px",
                            display: "flex",
                            flexDirection: "column"
                        }}
                    >
                        {/* Media Section */}
                        <Box>
                            <MediaHandler
                                media={getMediaObject(cardContent)}
                                thumbnail={getThumbnailObject(cardContent)}
                                height={getMediaHeight(cardContent)}
                                width="100%"
                                iconPosition="center"
                            />
                        </Box>

                        {/* Content Section */}
                        <Box padding={2} sx={{ flex: 1, display: "flex", flexDirection: "column" }}>
                            <Typography
                                variant="h6"
                                fontWeight="bold"
                                sx={{
                                    lineBreak: "auto",
                                    wordBreak: "break-word",
                                    padding: 1
                                }}
                            >
                                {truncateText(cardContent.title, 38)}
                            </Typography>

                            <Typography
                                variant="body2"
                                sx={{
                                    lineBreak: "auto",
                                    wordBreak: "break-word",
                                    padding: 1
                                }}
                            >
                                {truncateText(cardContent.description, 25)}
                            </Typography>

                            {/* Suggestions Section */}
                            <Box
                                sx={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    width: "100%",
                                    flexDirection: "column",
                                    paddingTop: 4,
                                    flex: 1
                                }}
                            >
                                {cardContent.suggestions.map((suggestion, suggestionIndex) => (
                                    <Box
                                        key={suggestionIndex}
                                        sx={{
                                            width: "100%",
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "center"
                                        }}
                                    >
                                        <SuggestionSimulatorComponentForCampaign
                                            suggestion={suggestion}
                                        />
                                        {suggestionIndex + 1 < cardContent.suggestions.length && (
                                            <Box
                                                sx={{
                                                    width: "60%",
                                                    height: "1px",
                                                    bgcolor: "black",
                                                    my: 1.5
                                                }}
                                            />
                                        )}
                                    </Box>
                                ))}
                            </Box>
                        </Box>
                    </Card>
                </Grid>
            ))}
        </Grid>
    );
}